import styles from '@/common/containers/ModuleOverview/styles.less';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Closing = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.blockBody}>
      <h4 className={styles.contentTitle}>
        {t('Closing tasks module overview')}
      </h4>
      <div className={styles.contentDescription}>
        {t('Formally close the estate management process.')}
      </div>
      <h3 className={styles.contentSubTitle}>{t('Instructions')}</h3>
      <div className={styles.contentStepper}>
        <Stepper orientation="vertical">
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t('Complete the “Closing tasks List”')}
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Timeframe')}</h3>
      <div className={styles.contentTimeFrame}>
        <ul>
          <ol>
            {t(
              'The “Closing tasks List” should only be started after ALL previous task lists (Immediate, Legal, Main, and Assets tasks) have been completed.'
            )}
          </ol>
        </ul>
      </div>
      <div className={styles.contentNoteWrap}>
        <div className="note">
          {t(
            'Closing tasks will formally close the estate management process. Therefore, it is imperative that:'
          )}
          <ul>
            <ol>
              {t(
                '1. All assets have been fully managed (i.e. transferred, disposed, sold, etc) in order to determine which have tax implications'
              )}
            </ol>
            <ol>
              {t(
                '2. All tasks that impact the decedent’s tax returns are completed and submitted'
              )}
            </ol>
            <ol>
              {t(
                '3. The estate tax returns have been accepted and any outstanding debts have been paid'
              )}
            </ol>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Closing;
